export default "__VITE_ASSET__BKaxc_IR__"